export default "__VITE_ASSET__N9Pzzx53__"